import { useLazyQuery, useMutation } from "@apollo/client/react"; import React, { useEffect, useState } from 'react';
import '../ri-ev-medico-creation.scss';
import { Grid, setRef } from '@mui/material';
import { TextInput } from '../../../components/textInput/TextInput';
import { SelectInput } from '../../../components/selectInput/SelectInput';
import { DropdownContent } from '../../../components/dropdownContent/DropdownContent';
import { Chip, Radio } from '@mui/material';

import { CustomButton } from '../../../components/customButton/CustomButton';
import moment from 'moment';
import 'moment/locale/es';

import { GET_DELEGACIONES_BY_USUARIO } from '../../../data/graphQL/queries/PacienteProbable/getAllDelegacionesByUsuario';
import { GET_PROFESIONALES_RI_EV } from '../../../data/graphQL/queries/RiEvMedico/getProfesionalesRIEV';
import { GET_PACIENTES_RI_EV } from '../../../data/graphQL/queries/RiEvMedico/getPacientesRIEV';
import { GET_CONTRATOS_RI_EV } from '../../../data/graphQL/queries/RiEvMedico/getContratosRIEV';
import { GET_TIPO_FORMULARIO_RI_EV } from '../../../data/graphQL/queries/RiEvMedico/getTipoFormularioRIEV';
import { GET_TALONARIOS_RI_EV } from '../../../data/graphQL/queries/RiEvMedico/getTalonariosRIEV';
import { GET_TALONARIO_EXISTE_RI_EV } from '../../../data/graphQL/queries/RiEvMedico/getTalonarioExisteRIEV';
import { CREATE_RI_EV } from '../../../data/graphQL/mutations/RiEvMedico/create';

import { adaptDelegacionArray } from '../../../adapters/delegacionAdapter';
import { adaptProfesionalArray } from '../../../adapters/profesionalAdapter';
import { adaptPacienteArray } from '../../../adapters/pacienteAdapter';
import { adaptContratoRIEVArray } from '../../../adapters/contratoRIEVAdapter';
import toast from 'react-hot-toast';

export default function RiEvMedico({ setChildrenAction }) {

  const storageId = sessionStorage.getItem('idUsuario');

  const [dataSave, setDataSave] = useState('');
  const [delegaciones, setDelegaciones] = useState([]);
  const [profesionales, setProfesionales] = useState([]);
  const [pacientes, setPacientes] = useState([]);
  const [contratos, setContratos] = useState([]);
  const [tipoFormulario, setTipoFormulario] = useState('');
  const [talonarios, setTalonarios] = useState([]);
  const [nuevoTalonario, setNuevoTalonario] = useState('');
  const [figurasMedico] = useState([
    { id: 1, displayName: 'Seguimiento' },
    { id: 3, displayName: 'Evaluador' }]
  );
  const [meses] = useState(
    [
      { id: 1, displayName: 'Enero' }, { id: 2, displayName: 'Febrero' }, { id: 3, displayName: 'Marzo' },
      { id: 4, displayName: 'Abril' }, { id: 5, displayName: 'Mayo' }, { id: 6, displayName: 'Junio' },
      { id: 7, displayName: 'Julio' }, { id: 8, displayName: 'Agosto' }, { id: 9, displayName: 'Septiembre' },
      { id: 10, displayName: 'Octubre' }, { id: 11, displayName: 'Noviembre' }, { id: 12, displayName: 'Diciembre' }]

  );
  const currentYear = moment().format('YYYY');
  const currentMonth = parseInt(moment().format('MM'), 10);
  let anios = [];
  for (var i = currentYear - 10; i <= currentYear; i++) {
    anios.push({ id: i, displayName: i });
  }

  const [disabledSave, setDisabledSave] = useState(true);
  const [chkReferencia, setChkReferencia] = useState(false);

  useEffect(() => {
    setChildrenAction(() =>
      <div>
        <CustomButton
          onClick={handleGrabar}
          size='small'
          title='Grabar cambios'
          variant='contained'
          disabled={disabledSave}>
          Grabar
        </CustomButton>
      </div>
    );
  }, [setChildrenAction, dataSave, talonarios, chkReferencia]);

  const [getDelegaciones, { loading: delegacionesLoading, data: delegacionesData }] = useLazyQuery(GET_DELEGACIONES_BY_USUARIO, {
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (!delegacionesData) return;

    setDelegaciones(adaptDelegacionArray(delegacionesData));
  }, [delegacionesData]);

  useEffect(() => {
    if (!delegacionesLoading) {
      getDelegaciones({ variables: { idUsuario: JSON.parse(storageId) } });
    }

    setDataSave((previousData) => ({
      ...previousData,
      mes: currentMonth - 1,
      anio: currentYear
    }));
  }, [storageId]);

  const handleChange = (e) => {
    const { value, name } = e.target;
    setDataSave((previousData) => ({
      ...previousData,
      [name]: value
    }));
  };

  const buscarProfesionales = () => {
    getProfesionales({
      variables: {
        filter: {
          idDelegacion: dataSave.delegacion,
          idTipoProfesional: dataSave.figuraMedico,
          mes: dataSave.mes,
          anio: dataSave.anio
        }
      }
    });
  };

  const [getProfesionales, { loading: profesionalesLoading, data: profesionalesData }] = useLazyQuery(GET_PROFESIONALES_RI_EV, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!profesionalesData) return;

    setProfesionales(adaptProfesionalArray(profesionalesData));
  }, [profesionalesData]);

  useEffect(() => {
    if (dataSave?.profesional > 0) {
      getPacientes({
        variables: {
          filter: {
            idDelegacion: dataSave.delegacion,
            idTipoProfesional: dataSave.figuraMedico,
            mes: dataSave.mes,
            anio: dataSave.anio,
            idProfesional: dataSave.profesional
          }
        }
      });

      limpiarPantalla();
    }
  }, [dataSave?.profesional]);

  const [getPacientes, { loading: pacientesLoading, data: pacientesData }] = useLazyQuery(GET_PACIENTES_RI_EV, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!pacientesData) return;

    setPacientes(adaptPacienteArray(pacientesData));
  }, [pacientesData]);

  useEffect(() => {
    if (dataSave?.paciente > 0) {
      getContratos({
        variables: {
          filter: {
            idDelegacion: dataSave.delegacion,
            idTipoProfesional: dataSave.figuraMedico,
            mes: dataSave.mes,
            anio: dataSave.anio,
            idProfesional: dataSave.profesional,
            idPaciente: dataSave.paciente
          }
        }
      });
    }
  }, [dataSave?.paciente]);

  const [getContratos, { loading: contratosLoading, data: contratosData }] = useLazyQuery(GET_CONTRATOS_RI_EV, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!contratosData) return;

    setContratos(adaptContratoRIEVArray(contratosData));

    if (contratosData.contratosRIEV.valorEsperado.length == 1) {
      setDataSave((previousData) => ({
        ...previousData,
        contrato: contratosData.contratosRIEV.valorEsperado[0].idEvaluacion
      }));
    }
  }, [contratosData]);

  useEffect(() => {
    if (dataSave?.contrato > 0) {
      getTipoFormulario({
        variables: {
          filter: {
            idEvaluacion: dataSave.contrato,
            idFiguraProfesional: dataSave.figuraMedico,
            idProfesional: dataSave.profesional,
            idTipoProfesional: 1
          }
        }
      });

      getTalonarios({
        variables: {
          filter: {
            idEvaluacion: dataSave.contrato,
            idProfesional: dataSave.profesional,
            idDelegacion: dataSave.delegacion,
            idPaciente: dataSave.paciente,
            idFiguraProfesional: dataSave.figuraMedico,
            mes: dataSave.mes,
            anio: dataSave.anio
          }
        }
      });

      setDisabledSave(false);
    } else {
      setDisabledSave(true);
    }
  }, [dataSave?.contrato]);

  const [getTipoFormulario, { loading: tipoFormularioLoading, data: tipoFormularioData }] = useLazyQuery(GET_TIPO_FORMULARIO_RI_EV, {
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (!tipoFormularioData) return;

    setTipoFormulario(tipoFormularioData.tipoFormularioRIEV.valorEsperado.referenciaFormulario);
    setDataSave((previousData) => ({
      ...previousData,
      idTipoFormulario: tipoFormularioData.tipoFormularioRIEV.valorEsperado.idTipoFormulario
    }));
  }, [tipoFormularioData])

  const [getTalonarios, { loading: talonarioLoading, data: talonariosData }] = useLazyQuery(GET_TALONARIOS_RI_EV, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!talonariosData) return;

    if (!!talonariosData.talonariosRIEV?.valorEsperado) {
      setDataSave((previousData) => ({
        ...previousData,
        idEvolucion: talonariosData.talonariosRIEV.valorEsperado.idEvolucion
      }));
      setTalonarios(talonariosData.talonariosRIEV.valorEsperado.talonarios);
    } else {
      setDataSave((previousData) => ({
        ...previousData,
        idEvolucion: 0
      }));
      setTalonarios([]);
    }
  }, [talonariosData]);

  const handleChangeTalonario = (event) => {
    const { value } = event.target;
    const regex = new RegExp("[0-9]+$");
    if (regex.test(value)) {
      setNuevoTalonario(value);
    } else if (value === '') {
      setNuevoTalonario('');
    }
  };

  const talonarioValido = () => {
    if (nuevoTalonario == "") {
      toast.error("El talonario no puede estar vacío.");
      return false;
    }

    const talonarioCompleto = String(nuevoTalonario).padStart(10, '0');
    if (talonarios.filter((t) => t.nroTalonario == talonarioCompleto).length > 0) {
      toast.error("El talonario ya fue agregado.");
      return false;
    }

    return true;
  };

  const agregarTalonario = () => {
    if (talonarioValido()) {
      setNuevoTalonario(String(nuevoTalonario).padStart(10, '0'));
      validarExistenciaTalonario({
        variables: {
          nroTalonario: String(nuevoTalonario).padStart(10, '0'),
          referencia: tipoFormulario
        }
      });
    }
  };

  const [validarExistenciaTalonario, { loading: validarTalonarioLoading, data: existenciaTalonariosData }] = useLazyQuery(GET_TALONARIO_EXISTE_RI_EV, {
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (!existenciaTalonariosData) return;

    if (!existenciaTalonariosData.talonarioExisteRIEV.valorEsperado) {
      setTalonarios([...talonarios, { nroTalonario: nuevoTalonario }]);
      setNuevoTalonario('');
    } else {
      toast.error("El talonario ya existe en el sistema.");
    }
  }, [existenciaTalonariosData]);

  const handleChangeReferencia = (e) => {
    setChkReferencia(e.target.checked);
  };

  const limpiarPantalla = () => {
    setDataSave((previousData) => ({
      ...previousData,
      paciente: 0,
      contrato: 0
    }));
    setTipoFormulario('');
    setTalonarios([]);
    setChkReferencia(false);
  };

  const [create, { error: createError }] = useMutation(CREATE_RI_EV, {
    onCompleted: (createData) => {
      if (createData.saveRIEVMedico.success) {
        toast.success("La evolución/ingreso se grabaron correctamente.");
        limpiarPantalla();
      } else {
        toast.error(createData.saveRIEVMedico.error);
      }
    }
  });

  const handleGrabar = () => {
    if (chkReferencia) {
      if (talonarios.length > 0) {
        let strTalonarios = "";
        for (var i = 0; i < talonarios.length; i++) {
          if (i > 0) {
            strTalonarios += ",";
          }

          strTalonarios += talonarios[i].nroTalonario;
        }
        const postData = {
          data: {
            idProfesional: dataSave.profesional,
            idPaciente: dataSave.paciente,
            idEvaluacion: dataSave.contrato,
            idFiguraProfesional: dataSave.figuraMedico,
            mes: parseInt(dataSave.mes, 10),
            anio: parseInt(dataSave.anio, 10),
            idTipoFormulario: dataSave.idTipoFormulario,
            idEvolucion: dataSave.idEvolucion,
            idUsuario: 0,
            talonarios: strTalonarios
          }
        };
        create({ variables: postData });
      } else {
        toast.error("Debe tener al menos 1 talonario cargado.");
      }
    } else {
      toast.error("Debe chequear la referencia del talonario.");
    }
  };

  return (
    <div className='general'>
      <Grid
        container
        justifyContent={'space-between'}
        columns={{
          xs: 12,
          md: 8
        }}
        gap={1}
        className='general grid-row'>

        <Grid size={{ xs: 3 }}>
          <SelectInput
            options={delegaciones}
            label='Delegación'
            onChange={handleChange}
            value={dataSave?.delegacion}
            name='delegacion' />

        </Grid>
        <Grid size={{ xs: 2 }}>
          <SelectInput
            options={figurasMedico}
            label='Figura médico'
            onChange={handleChange}
            value={dataSave?.figuraMedico}
            name='figuraMedico' />

        </Grid>
        <Grid size={{ xs: 2 }}>
          <SelectInput
            options={meses}
            label='Mes'
            onChange={handleChange}
            value={dataSave?.mes}
            name='mes' />

        </Grid>
        <Grid size={{ xs: 2 }}>
          <SelectInput
            options={anios}
            label='Año'
            onChange={handleChange}
            value={dataSave?.anio}
            name='anio' />

        </Grid>
        <Grid style={{ paddingTop: '5px' }} size={{ xs: 2 }}>
          <CustomButton
            className='custom-buttom-primary-color-2'
            onClick={buscarProfesionales}
            size='small'>

            Buscar
          </CustomButton>
        </Grid>
      </Grid>
      <DropdownContent sectionTitle={'Profesionales'} className='grid-row'>
        <Grid
          container
          className='general grid-row'
          sx={{ textAlign: 'left' }}>

          <Grid size={{ xs: 6 }}>
            <SelectInput
              options={profesionales}
              label='Profesional'
              onChange={handleChange}
              value={dataSave?.profesional}
              name='profesional' />

          </Grid>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <Grid size={{ xs: 5 }}>
            <SelectInput
              options={pacientes}
              label='Paciente'
              onChange={handleChange}
              value={dataSave?.paciente}
              name='paciente' />

          </Grid>
        </Grid>
        <Grid
          container
          justifyContent={'space-between'}
          className='general grid-row'>

          <Grid size={{ xs: 6 }}>
            <SelectInput
              options={contratos}
              label='Contrato'
              onChange={handleChange}
              value={dataSave?.contrato}
              name='contrato' />

          </Grid>
          <Grid size={{ xs: 2 }}>
            <div style={{ display: 'flex' }}>
              <TextInput
                type="text"
                label='Ref'
                placeholder='Ref'
                name='ref'
                value={tipoFormulario}
                disabled={true} />

              <Radio
                name='chkReferencia'
                checked={chkReferencia}
                onChange={handleChangeReferencia} />

            </div>
          </Grid>
          <Grid size={{ xs: 2 }}>
            &nbsp;
          </Grid>
          <Grid size={{ xs: 1 }}>
            &nbsp;
          </Grid>
        </Grid>
      </DropdownContent>

      <DropdownContent sectionTitle={'Talonarios'} className='grid-row'>
        <Grid
          container
          // justifyContent={'space-between'}           
          className='grid-row'
          gap={1}>

          <Grid size={{ xs: 2 }}>
            <TextInput
              type="text"
              onChange={handleChangeTalonario}
              label='Talonario'
              placeholder='Talonario'
              name='txtTalonario'
              value={nuevoTalonario} />

          </Grid>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <Grid style={{ paddingTop: '5px' }} size={{ xs: 1 }}>
            <CustomButton
              onClick={agregarTalonario}
              size='small'
              variant='outlined'>

              Agregar
            </CustomButton>
          </Grid>
          <Grid size={{ xs: 3, md: 12 }}>
            <div className='seccion-talonario-container'>
              <div className='talonario-grid-container'>
                <h4 className='seccion-talonario-title'>
                  Talonarios agregados
                </h4>

                {talonarios?.map((talonario) => {
                  return (
                    <Chip
                      className='talonario-chip'
                      size='small'
                      label={talonario.nroTalonario}
                      onDelete={() => {
                        setTalonarios(
                          talonarios.filter((d) => d.nroTalonario != talonario.nroTalonario)
                        );
                      }} />);


                })}
              </div>
            </div>
          </Grid>
        </Grid>
      </DropdownContent>
    </div>);

}